import { render, staticRenderFns } from "./tariff-history-popup.vue?vue&type=template&id=ca172aa4&scoped=true&"
import script from "./tariff-history-popup.vue?vue&type=script&lang=ts&"
export * from "./tariff-history-popup.vue?vue&type=script&lang=ts&"
import style0 from "./tariff-history-popup.vue?vue&type=style&index=0&id=ca172aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca172aa4",
  null
  
)

export default component.exports